import { scan } from 'react-scan';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StoreProvider } from '@/services/store';
import { App } from './app';
import { ErrorBoundary } from './error-boundary';
import 'modern-normalize/modern-normalize.css';
import './index.css';

scan({ enabled: window.location.hostname === 'localhost' });

const Root = () => {
  return (
    <ErrorBoundary>
      <StoreProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StoreProvider>
    </ErrorBoundary>
  );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
